import React, { useState, useRef } from 'react';
import useOutsidOfDOMClick from '../hooks/useOutsidOfDOMClick'; 

export default function NavItemDropdown(props) {
    const hoverTimeOutIdRef = useRef(false);
    const [open, toggle] = useState(false);
    const navItemDropdownRef = useOutsidOfDOMClick(() => {
        toggle(false);
    }, []);

    function toggleDropdown() {
        if (!open) {
            props.dropdownButtonClick && props.dropdownButtonClick();
        }

        toggle(open => !open);
    }

    function mouseEnter(hover) {
        if (!open) {
            return;
        }

        if (hover) {
            clearTimeout(hoverTimeOutIdRef.current);
        } else {
            hoverTimeOutIdRef.current = setTimeout(() => {
                toggle(false);
            }, 3000);
        }
    }

    return (
        <div
            ref={navItemDropdownRef}
            className={`dropdown top-nav__wallet ${open ? 'open' : ''}`}
            onMouseEnter={() => mouseEnter(true)}
            onMouseLeave={() => mouseEnter(false)}
        >
            <div className="btn btn-primary btn-withIcon dropdown-toggle" onClick={toggleDropdown}>
                {props.dropdownButton}
            </div>
            <div className={`dropdown-menu dropdown-menu-right ${props.dropdownMenuClassName}`}>
                {props.children}
            </div>
        </div>
    )
}